import { Customizations } from '@uifabric/utilities';
import { ExtendedPalette } from '../store/schema/ExtendedTheme';

export function applyCustomScopedSettings(palette: Partial<ExtendedPalette> = {}) {
    Customizations.applyScopedSettings('CommandBar', {
        styles: {
            root: {
                backgroundColor: palette.neutralLighter,
            },
        },
    });
    Customizations.applyScopedSettings('Icon', {
        styles: {
            root: {
                // For some reason, only in IE11, and only when deploying (not in gulp dev),
                // Fabric's `display: inline-block` style takes precedence over any custom
                // style we apply to the display property for icons. This causes visual regressions
                // in IE11 that look really bad.
                display: null,
            },
        },
    });
}
